module.exports = __webpack_public_path__ + "img/MetaMask-white.c229e8b1.png";